// ./src/contexts/EventTicketsContext/EventTicketsContext.tsx
//
// Thin context wrapper around useEventTickets (issued tickets / door sales).
// Mount with initialFilters={{ eventId: [eventId] }}. See PartnersContext.

import React, { createContext, useContext } from "react";

import { useEventTickets, UseEventTicketsOptions, UseEventTicketsReturn } from "@/hooks/useEventTickets";

const EventTicketsContext = createContext<UseEventTicketsReturn | null>(null);

export interface EventTicketsProviderProps extends UseEventTicketsOptions {
  children: React.ReactNode;
}

export const EventTicketsProvider: React.FC<EventTicketsProviderProps> = ({ children, ...options }) => {
  const value = useEventTickets(options);

  return <EventTicketsContext.Provider value={value}>{children}</EventTicketsContext.Provider>;
};

export const useEventTicketsContext = (): UseEventTicketsReturn => {
  const context = useContext(EventTicketsContext);

  if (!context) {
    throw new Error("useEventTicketsContext must be used within an <EventTicketsProvider>.");
  }

  return context;
};

export const useOptionalEventTicketsContext = (): UseEventTicketsReturn | null => {
  return useContext(EventTicketsContext);
};
